import * as React from "react"
import { Link } from "gatsby"
import { FooterLogo } from "../components/logo"

export default function Footer() {
  return (
    <div className="bg-pfb-navy pt-10 pb-16">
      <div className="max-w-6xl mx-auto px-5 flex flex-col md:flex-row lg:space-x-12 justify-between">
        <div className="w-56">
          <Link to="/">
            <FooterLogo />
          </Link>
        </div>
        <div className="flex flex-col md:flex-row justify-around flex-1 mt-8 space-y-10 md:space-y-0">
          {footerMenus.menus.map(menu => (
            <div key={menu.title}>
              <h4 className="text-pfb-blue text-sm font-bold mb-2">
                {menu.title}
              </h4>
              <ul>
                {menu.links.map(item => (
                  <li key={item.link_name}>
                    {item.type === "internal" ? (
                      <Link
                        to={item.link}
                        className="text-white underline underline-offset-2 hover:no-underline font-light text-sm py-2 inline-block"
                      >
                        {item.link_name}
                      </Link>
                    ) : (
                      <a
                        className="text-white underline underline-offset-2 hover:no-underline font-light text-sm py-2 inline-block"
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.link_name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const footerMenus = {
  menus: [
    {
      title: "1,800+ Projects",
      links: [
        {
          link: "/map",
          link_name: "Map",
          type: "internal",
        },
        {
          link: "/project-list",
          link_name: "Project List",
          type: "internal",
        },
        {
          link: "/stories",
          link_name: "Stories",
          type: "internal",
        },
        {
          link: "/about",
          link_name: "About",
          type: "internal",
        },
        {
          link: "/faq",
          link_name: "FAQ",
          type: "internal",
        },
      ],
    },
    {
      title: "Make a Difference",
      links: [
        {
          link: "https://www.peopleforbikes.org/take-action/im-for-bikes",
          link_name: "Sign up for Action Alerts",
          type: "external",
        },
        {
          link: "https://www.peopleforbikes.org/take-action/bambn-new-project-form",
          link_name: "Submit Your Project",
          type: "external",
        },
        {
          link: "/project-list",
          link_name: "Local Advocacy Groups",
          type: "internal",
        },
        {
          link: "https://www.peopleforbikes.org/take-action/local-innovation-signup?eid=129707",
          link_name: "Sign up for our Newsletter",
          type: "external",
        },
        {
          link: "mailto:infrastructure@peopleforbikes.org",
          link_name: "Contact us",
          type: "external",
        },
      ],
    },
    {
      title: "PeopleForBikes",
      links: [
        {
          link: "https://www.peopleforbikes.org/",
          link_name: "Main Site",
          type: "external",
        },
        {
          link: "https://cityratings.peopleforbikes.org/",
          link_name: "City Ratings",
          type: "external",
        },
        {
          link: "https://www.hungryforbatteries.org/",
          link_name: "Hungry for Batteries",
          type: "external",
        },
      ],
    },
  ],
}
